module.exports = __webpack_public_path__ + "static/media/Contele-Fleet-Tracking.3dd456a4.png";